import { COLORS } from '@constants';
import { Button } from '@ui';
import { Checkbox } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    &&& {
        background: ${COLORS.$shopify};
        border-color: ${COLORS.$shopify};

        &:hover {
            background: ${COLORS.$shopify};
            border-color: ${COLORS.$shopify};
        }

        &:active {
            background: ${COLORS.$shopify};
            border-color: ${COLORS.$shopify};
        }
    }
`;

export const StyledCheckbox = styled(Checkbox)`
    span {
        font-size: 16px;
        font-weight: 500;

        a {
            color: ${COLORS.$info};
        }
    }
`;
